import { render } from "./FlowIcon.vue?vue&type=template&id=93a52624"
import script from "./FlowIcon.vue?vue&type=script&lang=js"
export * from "./FlowIcon.vue?vue&type=script&lang=js"
script.render = render

export default script